export default __webpack_public_path__ + "_/images/hero/hero-private-b1b812bf5fa9d0e6e9b341e01b01a21ef371c888091a85d8d1601db957864673.png";